// CacheKey 23fc9ec1f57056dfaf9112941fa128b7
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    protips: {
      live_transfer: [
        "Click the slider next to a phone to enable/disable that phone for live transfers."
      ],
      provider_roles: [
        "You can assign several provider roles to a user, the permissions will be combined to provide greater access.",
        "Use provider roles to reuse common config across users, such as permissions and user criteria.",
        "Did you know you can define a provider role without specifying permissions?<br/>It's a great way to reuse criteria configurations :)",
        "By assigning a role with criteria to a user, you no longer need to manually configure criteria for the user!"
      ],
      rounding_script: [
        "Swiftly add questions by pressing <b ng-click='addQuestion()'>A</b>.",
        "Add a new answer quickly by pressing <b>ENTER</b> while editing an answer."
      ],
      units: [
        "Press <b>ESCAPE</b> to unselect all the selected units or departments.",
        "By clicking the checkbox in the search bar, you can quickly select all units or departments. Presto!",
        "Instead of selecting all items manually, you can narrow them down by using the search filters, and then use <b>Select All</b>. Nifty!"
      ],
      users: [
        "Press <b>ESCAPE</b> to unselect all the selected users.",
        "By clicking the checkbox in the search bar, you can quickly select all users.",
        "Instead of selecting all items manually, you can narrow them down by using the search filters, and then use <b>Select All</b>."
      ]
    }
  }
}

